var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4959_560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2052 11.745C22.3231 9.46324 20.7917 7.48996 18.8003 6.06906C16.8089 4.64817 14.4448 3.84193 12.0002 3.75C9.55556 3.84193 7.19146 4.64817 5.20007 6.06906C3.20868 7.48996 1.67729 9.46324 0.795169 11.745C0.735595 11.9098 0.735595 12.0902 0.795169 12.255C1.67729 14.5368 3.20868 16.51 5.20007 17.9309C7.19146 19.3518 9.55556 20.1581 12.0002 20.25C14.4448 20.1581 16.8089 19.3518 18.8003 17.9309C20.7917 16.51 22.3231 14.5368 23.2052 12.255C23.2647 12.0902 23.2647 11.9098 23.2052 11.745ZM12.0002 18.75C8.02517 18.75 3.82517 15.8025 2.30267 12C3.82517 8.1975 8.02517 5.25 12.0002 5.25C15.9752 5.25 20.1752 8.1975 21.6977 12C20.1752 15.8025 15.9752 18.75 12.0002 18.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7.5C11.11 7.5 10.24 7.76392 9.49994 8.25839C8.75991 8.75285 8.18314 9.45566 7.84254 10.2779C7.50195 11.1002 7.41283 12.005 7.58647 12.8779C7.7601 13.7508 8.18869 14.5526 8.81802 15.182C9.44736 15.8113 10.2492 16.2399 11.1221 16.4135C11.995 16.5872 12.8998 16.4981 13.7221 16.1575C14.5443 15.8169 15.2471 15.2401 15.7416 14.5001C16.2361 13.76 16.5 12.89 16.5 12C16.5 10.8065 16.0259 9.66193 15.182 8.81802C14.3381 7.97411 13.1935 7.5 12 7.5ZM12 15C11.4067 15 10.8266 14.8241 10.3333 14.4944C9.83994 14.1648 9.45543 13.6962 9.22836 13.148C9.0013 12.5999 8.94189 11.9967 9.05765 11.4147C9.1734 10.8328 9.45912 10.2982 9.87868 9.87868C10.2982 9.45912 10.8328 9.1734 11.4147 9.05764C11.9967 8.94189 12.5999 9.0013 13.1481 9.22836C13.6962 9.45542 14.1648 9.83994 14.4944 10.3333C14.8241 10.8266 15 11.4067 15 12C15 12.7956 14.6839 13.5587 14.1213 14.1213C13.5587 14.6839 12.7957 15 12 15Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4959_560"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.c7fe59945af414a40c31fc87d43ea6ca.svg";
export { ForwardRef as ReactComponent };